var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "messageBox sub-main"
    },
    [
      _c("div", { staticClass: "top2" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "headImg" }, [
            _c("img", { attrs: { src: _vm.userInfo.headImage, alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("div", [_vm._v(_vm._s(_vm.userInfo.phone))]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.userInfo.name))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _c("img", {
        attrs: { src: require("../../../assets/images/userCard.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "showMoney" }, [
        _c("div", [_vm._v("累计节省")]),
        _vm._v(" "),
        _c("div", [_vm._v("0")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "showMoney" }, [
        _c("div", [_vm._v("累计消费")]),
        _vm._v(" "),
        _c("div", [_vm._v("0")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2" }, [
      _c(
        "h2",
        {
          staticStyle: {
            "font-size": "20px",
            "margin-top": "20px",
            "font-weight": "600"
          }
        },
        [_vm._v("购买情况")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: {
              src: require("../../../assets/images/orderPrice.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("订单平均价格")]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [_vm._v("0")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: {
              src: require("../../../assets/images/buyNumber.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("购买数量")]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [_vm._v("0")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: {
              src: require("../../../assets/images/orderTotal.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("订单总数")]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [_vm._v("0")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: {
              src: require("../../../assets/images/dealNumber.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("签署合同数")]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [_vm._v("0")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: {
              src: require("../../../assets/images/favorablePrice.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("优惠金额")]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [_vm._v("0")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c18cbde2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c18cbde2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/center/personCenter.vue
// module id = null
// module chunks = 